<template>
  <div class="login site__centered">
    <div class="form">
      <div class="form__wrap login__form">
        <h2 class="form__title">Signing you in...</h2>
        <p
          v-if="errorMessage"
          class="form__error"
        >
          {{ errorMessage }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/libs/axios'
import useJwt from '@/auth/jwt/useJwt'
import { initialAbility } from '@/libs/acl/config'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'

export default {
  data() {
    return {
      errorMessage: null,
    }
  },
  beforeCreate() {
    const { token } = this.$route.params

    if (!token) {
      this.$router.replace({ name: 'auth-login' })
      return
    }

    localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
    localStorage.removeItem('userData')

    this.$store.commit('SET_USER_DATA', null)
    this.$store.commit('CHANGE_USER_STATUS', false)
    this.$store.commit('family/SET_FAMILY_ID', null)

    this.$ability.update(initialAbility)

    axios.post(`/user-auth/access-link/${token}`)
      .then(response => {
        const { userData } = response.data

        useJwt.setToken(response.data.accessToken)
        localStorage.setItem('userData', JSON.stringify(userData))
        this.$ability.update(userData.ability)

        this.$store.commit('CHANGE_USER_STATUS', userData.id)
        this.$store.commit('SET_USER_DATA', userData)

        this.$router.replace(getHomeRouteForLoggedInUser(userData.role))
      })
      .catch(() => {
        this.errorMessage = 'This Access Link is invalid, expired, or no longer active. Please request a new one.'
        setTimeout(() => {
          this.$router.replace({ name: 'auth-login' })
        }, 4000)
      })
  },
}
</script>

<style>
</style>

